/* MC · Wishlist locale + ajout rapide taille (cartes produit) */
(function () {
  var KEY = 'mc_wishlist';
  function getWish() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function setWish(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function paint(scope) {
    var list = getWish();
    (scope || document).querySelectorAll('[data-mc-wish]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-mc-wish')) !== -1;
      btn.classList.toggle('is-active', active);
      var label = btn.querySelector('[data-mc-wish-label]');
      if (label) label.textContent = active ? 'Dans ta wishlist' : 'Ajouter à la wishlist';
    });
    document.querySelectorAll('[data-mc-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-empty', list.length === 0);
    });
    document.dispatchEvent(new CustomEvent('mc:wishlist:change', { detail: { list: list } }));
  }
  window.mcWishlist = { get: getWish, repaint: paint };
  document.addEventListener('click', function (e) {
    var wish = e.target.closest('[data-mc-wish]');
    if (wish) {
      e.preventDefault();
      e.stopPropagation();
      var h = wish.getAttribute('data-mc-wish');
      var list = getWish();
      var i = list.indexOf(h);
      if (i === -1) list.push(h); else list.splice(i, 1);
      setWish(list);
      wish.classList.add('mc-wish--pop');
      setTimeout(function () { wish.classList.remove('mc-wish--pop'); }, 350);
      paint();
      return;
    }
    var qa = e.target.closest('[data-mc-qa-variant]');
    if (qa && !qa.hasAttribute('disabled')) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(qa.getAttribute('data-mc-qa-variant'), qa);
    }
  }, true);

  async function addToCart(variantId, btn) {
    btn.setAttribute('disabled', '');
    btn.classList.add('is-loading');
    var cartDrawer = document.querySelector('cart-drawer');
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    var body = { id: Number(variantId), quantity: 1 };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      var response = await res.json();
      if (res.ok && cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
        if (window.mcSheetClose) window.mcSheetClose();
        cartDrawer.renderContents(response);
      } else if (res.ok) {
        window.location.href = root + 'cart';
      }
    } catch (err) {} finally {
      btn.removeAttribute('disabled');
      btn.classList.remove('is-loading');
    }
  }

  document.addEventListener('DOMContentLoaded', function () { paint(); });
  document.addEventListener('shopify:section:load', function (e) { paint(e.target); });
  paint();
})();

/* === Feuille "Ajout rapide" mobile === */
(function () {
  var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
  var cache = {};
  var sheet, overlay;

  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'mc-sheet-overlay';
    sheet = document.createElement('div');
    sheet.className = 'mc-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', 'Ajout rapide');
    sheet.innerHTML =
      '<div class="mc-sheet__head"><span>AJOUT RAPIDE</span><button type="button" class="mc-sheet__close" aria-label="Fermer">&times;</button></div>' +
      '<div class="mc-sheet__product"></div>' +
      '<p class="mc-sheet__label">CHOISIS TA TAILLE</p>' +
      '<div class="mc-sheet__sizes"></div>';
    document.body.appendChild(overlay);
    document.body.appendChild(sheet);
    overlay.addEventListener('click', close);
    sheet.querySelector('.mc-sheet__close').addEventListener('click', close);
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('mc-sheet-lock');
  }
  window.mcSheetClose = close;

  function open(handle) {
    if (!sheet) build();
    var fill = function (p) {
      var img = p.featured_image || '';
      sheet.querySelector('.mc-sheet__product').innerHTML =
        (img ? '<img src="' + img + (img.indexOf('?') === -1 ? '?width=200' : '&width=200') + '" alt="">' : '') +
        '<div><p class="mc-sheet__title">' + p.title + '</p><p class="mc-sheet__price">' + money(p.price) + '</p></div>';
      sheet.querySelector('.mc-sheet__sizes').innerHTML = p.variants.map(function (v) {
        return '<button type="button" class="mc-sheet__size" data-mc-qa-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
          '<span>' + v.title + '</span><span class="mc-sheet__state">' + (v.available ? money(v.price) : 'Épuisé') + '</span></button>';
      }).join('');
      sheet.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('mc-sheet-lock');
    };
    if (cache[handle]) return fill(cache[handle]);
    fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[handle] = p; fill(p); })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mc-qa-open]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      open(btn.getAttribute('data-mc-qa-open'));
    }
  }, true);
})();
